import { RadioGroup } from '@mui/material';
import { forwardRef } from 'react';

export default forwardRef(({ children, ...rest }, ref) => {
    return (
        <RadioGroup ref={ref} {...rest} role={'group'}>
            {children}
        </RadioGroup>
    );
});
